import { render } from "./Coach.vue?vue&type=template&id=1510a672&scoped=true"
import script from "./Coach.vue?vue&type=script&lang=js"
export * from "./Coach.vue?vue&type=script&lang=js"

import "./Coach.vue?vue&type=style&index=0&id=1510a672&scoped=true&lang=css"
import "./Coach.vue?vue&type=style&index=1&id=1510a672&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1510a672"]])

export default __exports__